"use client";
import { jsxs as h, jsx as t } from "react/jsx-runtime";
import { Root as v, Trigger as w, Portal as b, Content as k, Arrow as C } from "@radix-ui/react-tooltip";
import { Provider as E } from "@radix-ui/react-tooltip";
import { forwardRef as O, useState as y, useEffect as H } from "react";
import { twMerge as T } from "tailwind-merge";
import { Text as c } from "./index.es4.js";
function W() {
  try {
    return matchMedia("(hover: hover)").matches;
  } catch {
    return !0;
  }
}
const R = O(
  ({
    className: d = "",
    contentProps: f = {},
    description: a,
    hasArrow: i = !0,
    title: r,
    trigger: u,
    variant: s = "dark",
    triggerProps: n = {},
    ...e
  }, m) => {
    const [o, l] = y(!1);
    H(() => {
      e != null && e.defaultOpen && l(!0);
    }, [e == null ? void 0 : e.defaultOpen]);
    const x = T(
      `rounded shadow-level1-soft p-3 z-[1050] ${s === "light" ? "bg-white text-black" : "bg-black text-white"}`,
      d
    ), g = a ? "semibold" : "regular";
    return W() || (e = {
      ...e,
      open: o,
      onOpenChange: () => l(!1)
    }, n = {
      ...n,
      onClick: () => l(!0)
    }), /* @__PURE__ */ h(v, { delayDuration: 0, ...e, children: [
      /* @__PURE__ */ t(w, { ref: m, asChild: !0, ...n, children: u }),
      (r || a) && /* @__PURE__ */ t(b, { children: /* @__PURE__ */ h(
        k,
        {
          "data-testid": "tooltip-content",
          className: x,
          sideOffset: 4,
          hideWhenDetached: !0,
          ...f,
          children: [
            i && /* @__PURE__ */ t(
              C,
              {
                className: `fill-current drop-shadow-level1-soft mask-clip ${s === "light" ? "text-white" : "text-black"}`,
                style: { clipPath: "inset(0 -10px -10px -10px)" }
              }
            ),
            /* @__PURE__ */ h("div", { className: "flex flex-col gap-y-1.5 max-w-xs", children: [
              r && /* @__PURE__ */ t(c, { fontSize: "sm", fontWeight: g, asChild: !0, children: /* @__PURE__ */ t("span", { children: r }) }),
              a && /* @__PURE__ */ t(c, { fontSize: "xs", fontWeight: "regular", children: a })
            ] })
          ]
        }
      ) })
    ] });
  }
);
export {
  R as Tooltip,
  E as TooltipProvider
};
